import React from 'react';
import CommentTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Comment';
import TextRenderer from '../../../TextRenderer';
import CommentViewer from '../../../DaEditorWrapper/Viewer/Comment';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './ContentTextRenderer.scss';
const ContentTextRenderer = ({ comment })=>{
    const { commentId, textContent } = comment;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['renderer'],
        textContent: textContent,
        reactViewer: CommentViewer,
        legacyTheme: 'comments',
        viewerKey: commentId,
        tipTapViewer: CommentTiptapViewer,
        cookieType: MeasuredCookieType.COMMENT_RENDERER,
        defaultSize: {
            desktop: {
                width: 580,
                height: 80
            },
            mobile: {
                width: 380,
                height: 80
            }
        }
    }));
};
ContentTextRenderer.displayName = 'ContentTextRenderer';
export default ContentTextRenderer;

//# sourceMappingURL=ContentTextRenderer.js.map